/**
 * `ExistingMemberLink` — a link to the member a refusal names
 * (`refs.existing_member_id`), on a line of its own, or nothing when the
 * refusal names none.
 *
 * Add member's duplicate refusals carry that id since duplicate-member-id
 * (2026-10-30), and `update_member`'s phone and Instagram conflicts since
 * update-member-refs (2026-11-01). One component, so Add member, the member
 * page's Phone and Instagram rows and the /data edit form all read the id the
 * same way. Only a staff caller is given the id (the chokepoint's `refs`), and
 * the member page it opens shows a member of any status.
 */

import type { JSX } from "react";
import { Link } from "react-router-dom";

export function ExistingMemberLink({
  refs,
  label,
  className,
}: {
  /** The failed dispatch's `refs`; undefined when the refusal named none. */
  readonly refs: Readonly<Record<string, string>> | undefined;
  readonly label: string;
  readonly className?: string | undefined;
}): JSX.Element | null {
  const existing = refs?.["existing_member_id"];
  if (existing === undefined) return null;
  return (
    <div className={className}>
      <Link to={`/members/${existing}`}>{label}</Link>
    </div>
  );
}
